const STORAGE_STATE = "mbv_state"


export function clearState(saved=[], clearFromStorage=false) {
	let state = JSON.parse(localStorage.getItem(STORAGE_STATE))
	if(state === null || state === undefined) { return }
	if(saved) {
		for (let key of Object.keys(state)) {
			if(!saved.includes(key)){
				delete state[key]
			}
		}
		localStorage.setItem(STORAGE_STATE, JSON.stringify(state));
	}
	if(clearFromStorage) {
		localStorage.removeItem(STORAGE_STATE)
	}
}

export function addToState(params) {
	let state = JSON.parse(localStorage.getItem(STORAGE_STATE))
	if(state === undefined || state === null) { state = {} }
	const result = {
		...state,
		...params
	}
	localStorage.setItem(STORAGE_STATE, JSON.stringify(result));
}

export function getState(){
	const state = localStorage.getItem(STORAGE_STATE)
	if(state === null || state === undefined) {
		return {}
	}
	return JSON.parse(state)
}

export function removeFromState(params=[]) {
	let state = JSON.parse(localStorage.getItem(STORAGE_STATE))
	if(params) {
		for (let key of Object.keys(state)) {
			if(params.includes(key)){
				delete state[key]
			}
		}
		localStorage.setItem(STORAGE_STATE, JSON.stringify(state));
	}
}